import { render } from "./MenuSidebarPearlAIScouting.vue?vue&type=template&id=635464ac&scoped=true&lang=html"
import script from "./MenuSidebarPearlAIScouting.vue?vue&type=script&lang=js"
export * from "./MenuSidebarPearlAIScouting.vue?vue&type=script&lang=js"

import "./MenuSidebarPearlAIScouting.vue?vue&type=style&index=0&id=635464ac&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635464ac"]])

export default __exports__